import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
const partnerBenefits = [
  "Expand client reach through enterprise-scale hiring programs",
  "Collaborate with hiring teams using structured workflows",
  "Use AI-powered candidate scoring to prioritize quality submissions",
  "Track performance metrics including response time and candidate quality",
  "Build long-term partnerships through transparent hiring outcomes",
];

export const PartnersPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-20 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Recruiter & Vendor Network
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          A Collaborative Ecosystem for Talent Partners
        </h1>

        <p className="mt-6 max-w-3xl text-[#D9E1E8]/80 text-lg">
          The AI Matters platform connects recruiter partners, staffing
          agencies, and hiring teams through a unified collaboration
          environment. Our ecosystem enables sourcing partners to
          participate in enterprise hiring programs with structured
          workflows and AI-powered candidate insights.
        </p>
      </section>


      {/* BENEFITS */}
      <Card className="border-white/10 bg-[#0B253C]/60">

        <CardHeader>
          <CardTitle className="text-2xl">
            Why Partners Work With The AI Matters
          </CardTitle>
        </CardHeader>

        <CardContent className="space-y-4">

          {partnerBenefits.map((benefit) => (
            <div
              key={benefit}
              className="rounded-lg border border-white/10 bg-[#071A2C]/70 px-5 py-4 text-[#D9E1E8]/80"
            >
              {benefit}
            </div>
          ))}

        </CardContent>

      </Card>


      {/* PARTNER ECOSYSTEM */}
      <section>

        <h2 className="text-3xl font-bold mb-6">
          Built for Modern Recruiting Partners
        </h2>

        <p className="max-w-4xl text-[#D9E1E8]/80">
          Recruiting partners play a critical role in helping organizations
          scale their hiring operations. The AI Matters platform provides
          a transparent system where recruiters can collaborate with hiring
          teams, submit qualified candidates, and track performance through
          measurable outcomes.
        </p>

        <p className="mt-4 max-w-4xl text-[#D9E1E8]/80">
          Our ecosystem rewards quality, responsiveness, and long-term
          collaboration while enabling recruiters to participate in
          enterprise hiring programs across multiple industries.
        </p>

      </section>


      {/* CTA */}
      <section className="glass-panel rounded-2xl p-10 text-center">

        <h2 className="text-3xl font-bold mb-4">
          Join the Recruiter Network
        </h2>

        <p className="max-w-2xl mx-auto text-[#D9E1E8]/80 mb-6">
          Become part of a growing network of recruiting partners helping
          organizations discover and hire exceptional talent through
          AI-powered hiring infrastructure.
        </p>

        <Link
          to="/recruiter-network"
          className="inline-block rounded-full bg-[#2EC4A6] px-8 py-3 font-semibold text-[#071A2C] hover:bg-[#6FE3C1]"
        >
          Apply to Become a Partner
        </Link>

      </section>

    </div>
  );
};